import React from 'react';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { GoalsIcon } from '@atlaskit/logo';

import { LinkMenuItem } from '@atlaskit/navigation-system';
import { useIntl } from '@atlassian/jira-intl';
import type { AppProps } from '../types.tsx';
import messages from './messages.tsx';

export function Goals({ onClick }: AppProps): React.JSX.Element {
	const { formatMessage } = useIntl();
	const url = 'https://home.atlassian.com/goals';

	return (
		<LinkMenuItem
			href={url}
			elemAfter={<LinkExternalIcon label="" spacing="spacious" size="small" />}
			elemBefore={<GoalsIcon shouldUseNewLogoDesign size="xsmall" />}
			target="_blank"
			onClick={onClick}
			testId="navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
		>
			{formatMessage(messages.goals)}
		</LinkMenuItem>
	);
}
